import React, { ForwardedRef, forwardRef } from 'react';
import { Box } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';

// We want the styling of this grid to match the styling of the SCUI Category Listing grid as closely as possible.
// The spacing applied to the Box matches the spacing applied to the SCUI ModuleCard.
const RecommendationsGrid = forwardRef(({
  gridItems
}: {
  gridItems: React.ReactElement[];
}, ref: ForwardedRef<HTMLDivElement>) => {
  return <Box className={styles.grid} ref={ref}>
        {gridItems}
      </Box>;
});
export default RecommendationsGrid;